import type { PaxType } from '../../admin/enum/paxType';
import type { ClosingPeriodType } from '../../admin/experiences/closingPeriod/closingPeriod';
import type { AvailabilityMode } from '../../admin/experiences/enum/availabilityMode';
import type { ExperienceAvailableDayLimit } from '../../admin/experiences/enum/experienceAvailableDayLimit';
import type { OpeningHours } from '../../admin/experiences/openingHours/openingHours';
import type { ExperienceDurationDescription } from '../../common/experiences/enum/experienceDurationDescription';
import type { OpeningConfiguration } from '../../common/openingConfiguration/openingConfiguration';
import type { PictureView } from '../../common/pictureView/pictureView';

export const enum ExtranetExperienceStatus {
  PUBLISHED = 'PUBLISHED',
  UNPUBLISHED = 'UNPUBLISHED',
  DELETED = 'DELETED',
}

/**
 * Extranet Hotel Experience Types
 */
export type ExtranetHotelExperience = {
  id: number;
  hotelId?: number;
  countryId?: number;
  categoryId: number;
  status: ExtranetExperienceStatus;
  maxPax?: number;
  minPax?: number;
  allowedPaxTypes: PaxType[];
  availableDayLimits?: ExperienceAvailableDayLimit[];
  closedDaysBeforeCheckIn?: number;
  maxQuantity?: number;
  isAlwaysIncludedWithNight: boolean;
  time?: string;
  openingHours?: OpeningHours;
  closingPeriods?: ClosingPeriodType[];
  coverPicture?: PictureView;
  emoji?: PictureView;
  openingConfiguration?: OpeningConfiguration;
  brand?: string;
  duration?: number;
  durationDescription?: ExperienceDurationDescription;
  location?: string;
  showInInventory: boolean;
  hotelPriority?: number;
  availabilityMode: AvailabilityMode;
  calendarId?: number;
  spaceIds: number[];
  isInPublishedPack: boolean;
};

export type ExtranetHotelExperiencesResponse = {
  experiences: ExtranetHotelExperience[];
  originals: ExtranetHotelExperience[];
};

export type ExperiencesResponse = {
  experiences: ExtranetHotelExperience[];
  originals: ExtranetHotelExperience[];
};
